// Avatar utility functions

/**
 * Gets a random default avatar from avatar1.png to avatar6.png
 * @returns {string} Path to random avatar
 */
export const getRandomDefaultAvatar = () => {
  const avatarNumber = Math.floor(Math.random() * 6) + 1;
  return `/avatar${avatarNumber}.png`;
};

/**
 * Gets default avatar for fallback (avatar1.png as default)
 * @returns {string} Path to default avatar
 */
export const getDefaultAvatar = () => {
  return '/avatar1.png';
};

/**
 * Gets the user's avatar URL, prioritizing uploaded profile pictures
 * @param {Object} user - User object with avatar_url and profile_picture_url
 * @returns {string} Avatar URL to display
 */
export const getUserAvatarUrl = (user) => {
  if (user?.profile_picture_url) {
    return user.profile_picture_url; // Uploaded S3 image
  }
  if (user?.avatar_url) {
    return user.avatar_url; // Random default avatar
  }
  return getDefaultAvatar(); // Final fallback
};